<template>
  <v-dialog v-model="show"
            :width="500"
            content-class="modal modal-round">

    <div class="close"
         @click="show = false">&times;</div>

    <i class="mdi mdi-information-outline"
       slot="activator">
    </i>

    <v-card>
      <pre>{{ formatedString }}</pre>
    </v-card>
  </v-dialog>
</template>

<script>

    export default {
      props: {
        objectContent: {
          type: String
        }
      },
        components: {
            
        },

        computed: {
          formatedString() {
            return JSON.stringify(JSON.parse(this.objectContent), null, "\t")
          }
        },

        data() {
            return {
              show: false,
            }
        },

        destroyed() {
        },
    }
</script>

<style scoped>
</style>
